import TextField from '@mui/material/TextField';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {StaticDatePicker} from '@mui/x-date-pickers/StaticDatePicker';
import React, {useState} from "react";
import {useEffect} from "react";
import {Chip, Grid, Stack, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import hu from "date-fns/locale/hu";
import useReservationQueries from "../../hooks/queries/useReservationQueries";
import {formatHuman} from "../../utils/dateUtils";


const SelectOnlyDate = ({reservationData, setNewDate}) => {
    const today = new Date()

    const [selectedDate, setSelectedDate] = useState(new Date())
    const [selectedSlot, setSelectedSlot] = useState({})
    const [month, setMonth] = useState(today.getMonth() + 1)
    const [year, setYear] = useState(today.getFullYear())
    const priceId = reservationData.price.id;
    const formattedDate = formatHuman(selectedDate);

    const {useFreeSlotsForDate, useMonthlyAvailability} = useReservationQueries()

    const {data:slots, } = useFreeSlotsForDate(priceId, formattedDate)
    const {data: availability} = useMonthlyAvailability(priceId, year, month)

    const theme = useTheme()

    const isAvailableForReserve = (date) => {
        if (availability === undefined) return false
        if (Object.keys(availability).includes(formatHuman(date))) return !availability[formatHuman(date)]
        return false
    }

    return <div className="data-container">
        <Stack direction={{xs: 'column', md: 'row'}} alignItems='center'>
            <div className="date-select-calendar">
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={hu}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        disablePast={true}
                        loading={availability === undefined}
                        openTo="day"
                        shouldDisableDate={isAvailableForReserve}
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        onMonthChange={(d) => {
                            const year = d.getFullYear()
                            const month = d.getMonth()
                            setMonth(month + 1)
                            setYear(year)
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
            </div>
            <div className="data-container-slots" style={slots?.length !== 0 ? {} : {display: 'flex'}}>
                {slots?.length !== 0 ? <>
                        <Typography variant="subtitle2" align="center">Szabad időpontok
                            - {formatHuman(selectedDate)}</Typography>
                        <Typography variant="body2" gutterBottom align="center">Válassz szabad időpontot az alábbiak
                            közül!</Typography>
                        <Grid container spacing={1}>
                            {slots?.map((s, i) => <Grid style={{display: 'flex', justifyContent: 'center'}} item xs={4}
                                                       md={3} key={`slot_${i}`}>
                                <Chip onClick={() => {
                                    setSelectedSlot(s)
                                    setNewDate({id:reservationData.id, date:formatHuman(selectedDate), slot:s})
                                }} label={s.start + '-' + s.end} style={{
                                    color: selectedSlot?.start === s.start ? 'white' : theme.palette.primary.main,
                                    backgroundColor: selectedSlot?.start === s.start ? theme.palette.primary['400'] : theme.palette.primary['20'],
                                    fontWeight: '600',
                                }}/>
                            </Grid>)}
                        </Grid>
                    </>
                    : <div style={{alignSelf: "center"}}>
                        <Typography variant="subtitle1" align="center">Erre a napra nincsenek szabad
                            időpontok!</Typography>
                        <Typography variant="body2" gutterBottom align="center">Válassz másik időpontot!</Typography>
                    </div>}
            </div>
        </Stack>
    </div>
}

export default SelectOnlyDate